import { ReactNode, useCallback } from 'react'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { Stack, styled, Typography } from '@mui/material'
import { BottomDrawer } from '$common/bottom-drawer'
import { SecondaryButton } from '$common/buttons'
import { nothing } from '$func/utils'
import { DownloadIcon } from '$common/icons'
import { t } from '$i18n'

const StyledBottomDrawer = styled(BottomDrawer)`
  z-index: ${({ theme }) => theme.zIndex.tooltip + 2};
`

const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  padding: 20px;
`

export interface Props {
  isOpen: boolean
  icon: ReactNode
  title: string
  description: string
  isFullScreen?: boolean
}
const downloadTwaSrc = import.meta.env.VITE_TWA_DOWNLOAD_SRC

export function InstallTwaLayout({
  isOpen,
  isFullScreen,
  icon,
  title,
  description,
}: Props) {
  const handleOnConfirm = useCallback(() => {
    window.open(downloadTwaSrc, '_blank')
  }, [])

  if (!isOpen) return null

  return (
    <StyledBottomDrawer
      isFullscreen={isFullScreen}
      isOpen
      onClose={isFullScreen ? nothing : closeCurrentModal}
    >
      <Stack
        sx={{
          padding: '64px 20px',
          boxSizing: 'border-box',
          gap: '16px',
        }}
      >
        {icon}
        <Text variant="h2" dir="auto" marginTop="32px">
          {title}
        </Text>

        <Text variant="paragraph1" dir="auto">
          {description}
        </Text>
      </Stack>
      <ButtonsContainer>
        <SecondaryButton
          text={t('forceUpdateTwa.button')}
          onClick={handleOnConfirm}
          startIcon={
            <DownloadIcon
              sx={{ width: '24px', height: '24px', color: 'neutral800' }}
            />
          }
        />
      </ButtonsContainer>
    </StyledBottomDrawer>
  )
}

const Text = styled(Typography)`
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
  text-align: center;
`
